/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Two_Fa_Use_AuthenticatorInputs */

const en_two_fa_use_authenticator = /** @type {(inputs: Two_Fa_Use_AuthenticatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use an authenticator code`)
};

const nl_two_fa_use_authenticator = /** @type {(inputs: Two_Fa_Use_AuthenticatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een authenticatorcode gebruiken`)
};

/**
* | output |
* | --- |
* | "Use an authenticator code" |
*
* @param {Two_Fa_Use_AuthenticatorInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const two_fa_use_authenticator = /** @type {((inputs?: Two_Fa_Use_AuthenticatorInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Two_Fa_Use_AuthenticatorInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_two_fa_use_authenticator(inputs)
	return en_two_fa_use_authenticator(inputs)
});